import { render, staticRenderFns } from "./DocumentTemplateViewForm.vue?vue&type=template&id=e22a0efe"
import script from "./DocumentTemplateViewForm.vue?vue&type=script&lang=js"
export * from "./DocumentTemplateViewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports